import { FC } from 'react';
import { TestStatus, WbTableCell } from '@agilelab/plugin-wb-platform';
import { IconButton, TableRow } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { TestResults } from './TestResults';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { Test } from '../types';
import { TaskDisclosure } from './TaskDisclosure';
import { useTestResults } from './hooks/useTestResult';

interface Props {
  test: Test;
}

export const TestTableRow: FC<Props> = ({ test }) => {
  const { policiesWithWarnings } = useTestResults(test);
  const { setSelectedTestRow, selectedTestRow } = useEditorPageContext();
  const open = selectedTestRow === test.id;

  const toggle = () => {
    setSelectedTestRow(open ? null : test.id);
  };

  return (
    <>
      <TableRow selected={selectedTestRow === test.id}>
        <WbTableCell>
          <IconButton aria-label="expand row" size="small" onClick={toggle}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </WbTableCell>
        <WbTableCell>
          <TestStatus
            status={test.status}
            okWithWarnings={!!policiesWithWarnings}
            variant="reduced"
          />
        </WbTableCell>
        <WbTableCell>
          {format(parseISO(test.startDate), 'yyyy/MM/dd HH:mm:ss')}
        </WbTableCell>
        <WbTableCell>
          <TestResults test={test} />
        </WbTableCell>
      </TableRow>

      <TaskDisclosure test={test} />
    </>
  );
};
